import { render, staticRenderFns } from "./fulfilGiveFullReduction.vue?vue&type=template&id=647d9b96&"
import script from "./fulfilGiveFullReduction.vue?vue&type=script&lang=js&"
export * from "./fulfilGiveFullReduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports